import api from '@/api/api.js'

export default {
    getAnalyses() {
        const promise = api.clinique().get("/analyses");
        return promise.then((response) => response.data);
    },
    getCategoriesAnalyse() {
        const promise = api.clinique().get("categories_analyses");
        return promise.then((response) => response.data);
    },

    getAnalysesEnCours() {
        const promise = api.clinique().get("/analyses/facture/en-cours");
        return promise.then((response) => response.data);
    },

    storeBonAnalyse(idPatient, data) {
        const promise = api
            .clinique()
            .post(`/patient_externe/${idPatient}/select-analyses`, data);
        return promise.then((response) => response.data);
    },
    getAnalysesForConsult(idConsult, bought) {
        const promise = api
            .clinique()
            .get(`consultations/${idConsult}/get-analyses/${bought}`);
        return promise.then((response) => response.data);
    },
    updateBulAnalyse(data) {
        const promise = api
            .clinique()
            .post(`/consultation-bulletins-analyses2/save_operation`, data);
        return promise.then((response) => response.data);
    },

    solderAnalyseDiffere(data) {
        const promise = api
            .clinique()
            .post(`/analyses/paiement_differe`, data);
        return promise.then((response) => response.data);
    },

    getAllAnalysesForExterne() {
        const promise = api.clinique().get(`analyses-des-patients-externes/all`);
        return promise.then((response) => response.data);
    },

    getBulletinAnalyseSanConsultation() {
        const promise = api.clinique().get(`analyses/bon/sans-consultation`);
        return promise.then((response) => response.data);
    },

    selectAnalyse(id, data) {
        const promise = api.clinique().post('/consultations/' + id + '/select-analyses', data)
        return promise.then((response) => response.data)
    },

    getPrixAssurBonAnalyse(data) {
        const promise = api.clinique().post('/bon/analyses', data)
        return promise.then((response) => response.data)
    },

    getRefBonAnalyse() {
        const promise = api.clinique().get('/bon/reference/analyse')
        return promise.then((response) => response.data)
    },

    savePendingAnalyse(data) {
        const promise = api.clinique().post('/bon/analyse/paiement', data)
        return promise.then((response) => response.data)
    },

    getListBuletinAnalyses(data) {
        const promise = api.clinique().post('/bulletins-analyses/liste', data)
        return promise.then((response) => response.data)
    },
};